export const X_CLIENT_TYPE_HEADER = 'x-client-type';
export const CLIENT_TYPE_WEB = 'web';
export const clientTypeHeaders: Record<string, string> = {
  [X_CLIENT_TYPE_HEADER]: CLIENT_TYPE_WEB,
};
